<template>
  <div class="uploader-unsupport" v-show="!support">
    <slot>
      <p>
        很遗憾，您的浏览器不支持上传. 详细信息请参考： <a href="http://www.w3.org/TR/FileAPI/">the HTML5 File API</a> .
      </p>
    </slot>
  </div>
</template>

<script>
  import { uploaderMixin, supportMixin } from '../common/mixins'

  const COMPONENT_NAME = 'uploader-unsupport'

  export default {
    name: COMPONENT_NAME,
    mixins: [uploaderMixin, supportMixin]
  }
</script>

<style>
  .uploader-unsupport {
    position: relative;
    z-index: 10;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/upload/components/unsupport.vue